<template>
  <div class="modal-card bg-white rounded" style="width: 520px; max-width: 92vw;">
    <div class="bg-primary-100 p-4 text-xl">
      {{ isEdit ? 'Modifier' : 'Créer' }} un community manager
    </div>

    <div class="grid grid-cols-2 gap-4 p-4">
      <t-input-group
        class="col-span-2"
        label="Adresse e-mail"
        :variant="{ danger: emailError }"
        :feedback="emailError ? 'Veuillez renseigner une adresse e-mail valide.' : ''"
      >
        <t-input
          v-model="form.email"
          type="email"
          placeholder="email@exemple.fr"
          @blur="validateEmail"
        />
      </t-input-group>

      <t-input-group label="Nom">
        <t-input
          v-model="form.lastname"
          placeholder="Nom"
        />
      </t-input-group>

      <t-input-group label="Prénom">
        <t-input
          v-model="form.firstname"
          placeholder="Prénom"
        />
      </t-input-group>

    </div>

    <div class="bg-gray-50 px-4 py-3 flex gap-3 justify-end border-t border-t-gray-300">
      <t-button
        class="m-0"
        variant="secondary"
        @click="$parent.close()"
      >
        Annuler
      </t-button>
      <t-button
        :disabled="saving"
        @click.prevent="save"
      >
        {{ isEdit ? 'Mettre à jour' : 'Créer' }}
      </t-button>
    </div>
  </div>
</template>

<script>
import { http } from '@/services/api.service'

export default {
  name: 'app-dashboard-internal-team-community-manager-form',
  props: {
    manager: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      saving: false,
      emailError: false,
      form: {
        email: '',
        firstname: '',
        lastname: ''
      }
    }
  },
  computed: {
    isEdit () {
      return Boolean(this.manager && this.manager.uuid)
    }
  },
  created () {
    if (!this.manager) {
      return
    }

    this.form = {
      email: this.manager.email || '',
      firstname: this.manager.firstname || '',
      lastname: this.manager.lastname || ''
    }
  },
  methods: {
    validateEmail () {
      const email = String(this.form.email || '').trim()
      this.emailError = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      return !this.emailError
    },
    async save () {
      if (!this.validateEmail()) {
        return
      }

      this.saving = true

      const payload = {
        email: String(this.form.email || '').trim(),
        firstname: this.normalizeNullableString(this.form.firstname),
        lastname: this.normalizeNullableString(this.form.lastname)
      }

      try {
        const request = this.isEdit
          ? http.put(`/community-manager/${this.manager.uuid}`, payload)
          : http.post('/community-manager', payload)
        const { data } = await request

        this.$emit('saved', data)
        this.$parent.close()
      } catch (err) {
        const message = err?.response?.data?.message || 'Erreur lors de l\'enregistrement du community manager.'
        this.$notify({
          group: 'maviepro-error',
          text: message
        })
      } finally {
        this.saving = false
      }
    },
    normalizeNullableString (value) {
      const normalized = String(value || '').trim()
      return normalized === '' ? null : normalized
    }
  }
}
</script>
